import { lazy } from "react";

const UpdatesData = lazy(() => import("./index"));

export default UpdatesData